import { Modal, Button, Group, Stack, Text } from "@mantine/core";

interface VerbalConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /** Disables the buttons while the verbal-confirmation re-send is in flight. */
  isLoading?: boolean;
}

// Shown when the first /forms/send-manual POST returns
// {sent:false, reason:"opted_out"}. Staff must confirm verbally with the
// client that an SMS is OK before re-posting with
// verbal_confirmation_from_client=true.
export default function VerbalConfirmationModal({
  opened,
  onClose,
  onConfirm,
  isLoading = false,
}: VerbalConfirmationModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Client has SMS turned off"
      centered
      size="md"
    >
      <Stack gap="md">
        <Text size="sm">
          This client has <strong>Do not send transaction messages</strong> in
          their setting preferences. Please confirm with client that it is
          alright to send them this text to fill out this appointment's forms.
        </Text>
        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            color="var(--brand-teal)"
            onClick={onConfirm}
            loading={isLoading}
          >
            Send anyway
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
